import QRCode from 'qrcode';
import { useEffect, useRef, useState } from "react";
import { Button, Col, Form, FormGroup, Row, Spinner } from "react-bootstrap";

export interface TokenPanelProps
{
  readonly secretOk: boolean;
  readonly now: Date;
  readonly secret: string;
  readonly uri: string;
  readonly token: string;
  setSecret: (v: string) => void;
  setRandomSecret: () => void;
  setDefaultSecret: () => void;
}

export function TokenPanel(props: TokenPanelProps)
{
  return (
    <Row>
      <Form>
        <FormGroup>
          <Form.Label>Current time</Form.Label>
          <Form.Control type="text" readOnly value={props.now.toISOString()} />
        </FormGroup>
        <FormGroup>
          <Form.Label>Secret</Form.Label>
          <Form.Control
            type="text"
            value={props.secret}
            onChange={(e) => props.setSecret(e.target.value)}
            isInvalid={!props.secretOk}
          />
          <Form.Control.Feedback type="invalid">
            Too short!
          </Form.Control.Feedback>
        </FormGroup>
        <FormGroup>
          <Row>
            <Col md={1} xs={6}>
              <Button className="mt-1" onClick={() => props.setRandomSecret()} >
                Random
              </Button>
            </Col>
            <Col md={1} xs={6}>
              <Button className="mt-1" onClick={() => props.setDefaultSecret()} >
                Default
              </Button>
            </Col>
          </Row>
        </FormGroup>
        {props.secretOk &&
          <>
            <FormGroup>
              <Form.Label>URI</Form.Label>
            </FormGroup>
            <FormGroup>
              <Form.Text>
                <small>
                  <a href={props.uri}>{props.uri}</a>
                </small>
              </Form.Text>
            </FormGroup>
            <FormGroup>
              <Form.Label>QR</Form.Label>
            </FormGroup>
            <FormGroup>
              <Form.Text>
                <UriQRCode uri={props.uri} />
              </Form.Text>
            </FormGroup>
            <FormGroup>
              <Form.Label>Token</Form.Label>
              <Form.Control type="text" value={props.token} readOnly />
            </FormGroup>
          </>
        }
      </Form>
    </Row>
  )
}

export function UriQRCode(props: { uri: string })
{
  const [ready, setReady] = useState<string | undefined>();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() =>
  {
    const canvas = canvasRef.current;
    if (canvas)
    {
      QRCode
        .toCanvas(canvas, props.uri)
        .finally(() => setReady(props.uri));
    }
  }, [props.uri]);

  return <>
    {(ready === props.uri) ||
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    }
    <canvas ref={canvasRef} />
  </>
}